import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Style from './index.module.less'

export default class extends Component {
  render() {
    return (
      <HeaderView title="四大商家邀请">
        <div className={Style.content}>
          <iframe src="/p/wedding/Public/wap/m/emcee-invite/#/index" />
        </div>
      </HeaderView>
    )
  }
}
